import CONF from 'config/conf.singleton';
import USER_ROLE from 'constants/role';
import { AUTH_API } from 'middleware/api';
import logger from 'utils/logger.util';

import { PERMISSION_ACCESS_FAILURE, PERMISSION_ACCESS_REQUEST, PERMISSION_ACCESS_SUCCESS } from 'salon/constants';

const L = logger('addUserRole');

const addUserRole = ({ salonId, userRole }) => {
  if (userRole !== USER_ROLE.manager && userRole !== USER_ROLE.receptionist) {
    L.warn('Invalid userRole:', userRole, 'for salonId:', salonId);
  }

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      authenticated: true,
      config: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ permission: userRole }),
      },
      endpoint: `salon/v2/permission/${salonId}/`,
      pinSafe: true,
      types: [PERMISSION_ACCESS_REQUEST, PERMISSION_ACCESS_SUCCESS, PERMISSION_ACCESS_FAILURE],
    },
  };
};

// noinspection JSUnusedGlobalSymbols
export default addUserRole;
